/****************************************************
 * Module Name:  fancyColorProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class FancyColorProxy {
    static GetAllFancyColor = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/fancycolor",
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetAllFancyColorMini = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/fancycolor/mini",
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetSingleFancyColor = (colorId, callback) => {
        let params = {
            id: colorId,
        };

        restAPICall(
            Constants.MANAGER_URL + "/fancycolor",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static CheckFancyColorAvailable = (fancycolor, callback) => {
        let params = {
            fancycolor: fancycolor,
        };

        restAPICall(
            Constants.MANAGER_URL + "/fancycolor/available",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static AddFancyColor = (color, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/fancycolor",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(color),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static UpdateFancyColor = (color, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/fancycolor",
            "put",
            Constants.userToken,
            undefined,
            JSON.stringify(color),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };
}
